
import { IconButton, Stack } from '@mui/material';
import { Cancel, CheckCircle, Remove, Add } from '@mui/icons-material';
import Model from '../models/model';

const BiButtons = ({ inputProps }) => {
	const { formik } = inputProps;
	return (
		<Stack direction="row" spacing={2} sx={{
			'& .MuiIconButton-root': {
				'&.IsSelected': {
					backgroundColor: (theme) => theme.palette.divider,
				}
			}
		}}>
			<IconButton className={parseInt(formik.values.BIResult) === 1 ? 'IsSelected' : ''} color="error" onClick={() => { formik.setFieldValue('BIResult', 1) }}>
				<Add fontSize='inherit' />
			</IconButton>
			<IconButton className={parseInt(formik.values.BIResult) === 2 ? 'IsSelected' : ''} color="success" onClick={() => { formik.setFieldValue('BIResult', 2) }}>
				<Remove fontSize='inherit' />
			</IconButton>

		</Stack>
	)
}
const CiResultButton = ({ inputProps }) => {
	const { formik, activeRecord } = inputProps;
	return (
		<Stack direction="row" spacing={2} sx={{
			'& .MuiIconButton-root': {
				'&.IsSelected': {
					backgroundColor: (theme) => theme.palette.divider,
				}
			}
		}}>
			<IconButton color="success" className={parseInt(activeRecord.CIResult) === 1 ? 'IsSelected' : ''} onClick={() => {
				formik.setFieldValue('CIResult', 1)
				activeRecord.CIResult = 1
			}}>
				<CheckCircle fontSize='inherit' />
			</IconButton>
			<IconButton color="error" className={parseInt(activeRecord.CIResult) === 2 ? 'IsSelected' : ''} onClick={() => {
				formik.setFieldValue('CIResult', 2)
				activeRecord.CIResult = 2
			}}>
				<Cancel fontSize='inherit' />
			</IconButton>
		</Stack>
	)
}
const model = new Model({
	name: 'IncubatorCycle',
	onFormLoad: ({ formik, activeRecord }) => {
		if (!activeRecord.id) {
			formik.setFieldValue('BIResult', undefined);
			formik.setFieldValue('CIResult', undefined);
		}
		if (activeRecord.BIResult === 0) {
			formik.setFieldValue('BIResult', undefined);
		}
	},
	customizeSaveData: (toSave, { activeRecord }) => {
		const { combos } = activeRecord;
		const { BILotNumber, CILotNumber } = combos;
		const ciLotNumber = CILotNumber?.find((data) => (data.DisplayValue === toSave.CILotNumberId));
		const biLotNumber = BILotNumber?.find((data) => data.DisplayValue === toSave.BILotNumberId);
		toSave.CILotNumberId = ciLotNumber ? ciLotNumber?.id : toSave.CILotNumberId;
		toSave.BILotNumberId = biLotNumber ? biLotNumber?.id : toSave.BILotNumberId;
	},
	columns: [
		{ header: 'LotNumber', field: 'BILotNumberId', lookup: 'BILotNumber' },
		{ header: 'ExpiryDate', field: 'ExpiryDate', type: 'date' },
		{ header: 'BIResult', field: 'BIResult', customizeInput: BiButtons, required: true, type: 'number' },
		{ header: 'LotNumber', field: 'CILotNumberId', lookup: 'CILotNumber' },
		{ header: 'CIResult', field: 'CIResult', customizeInput: CiResultButton, required: true, type: 'number' },

	]
});
export const BICIResultTableModel = model;
export default model.createFormBase();
